import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

/** Returns the current URL search parameters and a function to update them */
export const useUrlSearch = () => {
  const history = useHistory();

  // Use location from separate hook, because useHistory doesn't re-render the page on url change
  const location = useLocation();

  const searchLocation = location.search;

  const search = useMemo(
    () => new URLSearchParams(searchLocation),
    [searchLocation]
  );

  const setSearch = useCallback(
    (params: URLSearchParams) => {
      if (params.toString() !== searchLocation) {
        history.replace({ search: params.toString() });
      }
    },
    [history, searchLocation]
  );

  return { search, setSearch };
};
